import { render } from "./FreightList.vue?vue&type=template&id=366911cb"
import script from "./FreightList.vue?vue&type=script&lang=js"
export * from "./FreightList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__